import Vue from 'vue';
/**
 * General component that can be used in dynamic component:is in vue
 * to skip parent element rendering
 */
export default Vue.extend({
  functional: true,
  inheritAttrs: false,
  render(_, { children }) {
    return children;
  },
});